import { render, staticRenderFns } from "./AdministrationDetailviewLayout.vue?vue&type=template&id=391ad9ca"
import script from "./AdministrationDetailviewLayout.vue?vue&type=script&lang=ts"
export * from "./AdministrationDetailviewLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports